var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrackedNotSelectedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13217_28729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.36783 8.37071L5.50026 8.37658C5.58806 8.38367 5.67519 8.39757 5.76089 8.41796L5.8891 8.45337L5.8908 8.45423L6.51414 8.65833L6.69633 8.71318C7.60933 8.97153 8.58021 8.95356 9.48489 8.65833L10.1083 8.45423L10.11 8.45337L10.2382 8.41796C10.3671 8.38712 10.4991 8.37114 10.6329 8.37071H10.8792C11.7095 8.3708 12.5055 8.70126 13.0926 9.28843C13.6796 9.87552 14.0102 10.6715 14.0103 11.5018V12.3579C14.0097 12.7226 13.8796 13.0754 13.6434 13.3532C13.407 13.6311 13.0796 13.8162 12.7198 13.8753H12.7189C9.59364 14.386 6.4054 14.386 3.28017 13.8753C2.53592 13.754 1.98962 13.1113 1.98962 12.357V11.5018C1.9897 10.6715 2.31956 9.87552 2.90651 9.28843C3.4937 8.70126 4.29027 8.37071 5.12068 8.37071H5.36783ZM7.99953 1.73828C9.47997 1.73828 10.6801 2.93844 10.6801 4.41891C10.6801 5.89938 9.47997 7.09954 7.99953 7.09954C6.51922 7.09935 5.31891 5.89927 5.31891 4.41891C5.31891 2.93856 6.51922 1.73847 7.99953 1.73828Z",
    stroke: "#5C5C5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13217_28729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackedNotSelectedIcon);
export default __webpack_public_path__ + "static/media/tracked-not-selected-icon.7e9a3d418eb859ba9eb027a834ae74b1.svg";
export { ForwardRef as ReactComponent };